<div class="min-h-screen bg-gray-100 p-6">
        <h1 class="text-3xl font-bold text-gray-800 mb-6">Task Completion Report</h1>
        
        <!-- Date Range Selector -->
        <form (ngSubmit)="applyDateRange()" class="bg-white shadow-lg rounded-lg p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-4">Select Date Range</h2>
          <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <input type="date" id="start-date" name="start-date" [(ngModel)]="startDate" class="border border-gray-300 p-2 rounded w-full sm:w-auto">
            <input type="date" id="end-date" name="end-date" [(ngModel)]="endDate" class="border border-gray-300 p-2 rounded w-full sm:w-auto">
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full sm:w-auto">Apply</button>
          </div>
        </form>
        
        <div *ngIf="showResult">
        <!-- Summary Statistics -->
        <div class="bg-white shadow-lg rounded-lg p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-4">Summary Statistics</h2>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div class="bg-gray-50 p-4 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-gray-800">Total Completed Tasks</h3>
              <p class="text-2xl font-bold text-gray-900">{{ reportData?.totalCompletedTasks || '0' }}</p>
            </div>
            <div class="bg-gray-50 p-4 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-gray-800">Tasks Completed by Role</h3>
              <p class="text-xl font-bold text-gray-900">Parts Coordinator: {{ reportData?.tasksCompletedByRole?.['parts coordinator'] || '0' }}</p>
              <p class="text-xl font-bold text-gray-900">GM: {{ reportData?.tasksCompletedByRole?.gm || '0' }}</p>
              <p class="text-xl font-bold text-gray-900">CSR: {{ reportData?.tasksCompletedByRole?.csr || '0' }}</p>
              <p class="text-xl font-bold text-gray-900">Estimator: {{ reportData?.tasksCompletedByRole?.estimator || '0' }}</p>
            </div>
          </div>
        </div>
      
        <!-- Technician Data -->
        <div class="bg-white shadow-lg rounded-lg p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-4">Technician Data</h2>
          <div class="grid grid-cols-1 gap-6">
            <div class="bg-gray-50 p-4 rounded-lg shadow">
              <h4 class="text-lg font-semibold text-gray-800">Total Created Tasks By All Techs</h4>
              <p class="text-2xl font-bold text-gray-900">{{ reportData?.totalTasksByTechGroup || '0' }}</p>
            </div>
          </div>
        </div>
      
        <!-- Technician's Total Created Tasks -->
        <div class="bg-white shadow-lg rounded-lg p-6 mb-6 border border-gray-200">
          <h2 class="text-lg font-semibold text-gray-800 mb-4">Technician's Total Created Tasks</h2>
          <div class="space-y-4">
            <div *ngFor="let tech of reportData?.tasksCreatedByTech | keyvalue" class="p-4 bg-gray-50 rounded-lg shadow-md border border-gray-300 flex items-center space-x-4">
              <!-- Colored Circle with Initials -->
              <div class="w-12 h-12 flex items-center justify-center rounded-full bg-blue-500 text-white text-xl font-semibold">
                {{ getInitials(tech.key) }}
              </div>
              <div>
                <h3 class="text-xl font-semibold text-gray-800">{{ tech.key }}</h3>
                <p class="text-lg font-bold text-gray-900 mt-2">Total Created Tasks: {{ tech.value }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Detailed Table -->
        <div class="bg-white shadow-lg rounded-lg p-6 mb-6">
                <!-- Accordion Header -->
                <button (click)="toggleAccordion()" class="w-full text-left text-xl font-semibold text-gray-800 mb-4 flex justify-between items-center">
                  Detailed Task List
                  <svg [class.rotate-180]="isAccordionOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              
                <!-- Accordion Content --> 
                
                        <div *ngIf="isAccordionOpen" class="bg-white shadow-lg rounded-lg p-6 mb-6 overflow-x-auto">
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                              <tr>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Assigned To</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Request Name</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Completed By</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr *ngFor="let task of reportData?.detailedTasks">
                                <td class="px-6 py-4 whitespace-nowrap">{{ task.employee.name }}</td>
                                <td class="px-6 py-4 whitespace-nowrap">{{ task.request.name }}</td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                  <ng-container *ngFor="let person of task.completedBy; let isLast = last"> 
                                    {{ person.name }}<ng-container *ngIf="!isLast">, </ng-container>
                                  </ng-container>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
        </div>
                      
              
        
        <!-- Export Options -->
        <div class="bg-white shadow-lg rounded-lg p-6">
          <h2 class="text-xl font-semibold text-gray-800 mb-4">Export Options</h2>
          <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <button class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-full sm:w-auto" disabled>Export as CSV</button>
            <button class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-full sm:w-auto" disabled>Export as PDF</button>
          </div>
        </div>

        </div>
</div>
      